import { useMemo } from 'react'

import {
  Endorsement,
  EndorsementDescriptions,
} from 'src/graphql/types/licenses'

import { FilterOption } from '../types'

interface UseEndorsementsFilterProps {
  selectedEndorsements: string[]
  onEndorsementsChange: (endorsements: string[]) => void
}

export const useEndorsementsFilter = ({
  selectedEndorsements,
  onEndorsementsChange,
}: UseEndorsementsFilterProps) => {
  const baseOptions = useMemo<FilterOption[]>(() => {
    return Object.values(Endorsement).map((endorsement) => ({
      value: endorsement,
      label: `${endorsement} - ${EndorsementDescriptions[endorsement]}`,
    }))
  }, [])

  // Update options to reflect selected state
  const options = useMemo<FilterOption[]>(() => {
    return baseOptions.map((option) => ({
      ...option,
      selected: selectedEndorsements.includes(option.value),
    }))
  }, [baseOptions, selectedEndorsements])

  return {
    options,
    selected: selectedEndorsements,
    onChange: onEndorsementsChange,
    isLoaded: true,
  }
}
